import { useEffect, useRef } from 'react'
import { useInView, animate } from 'framer-motion'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'
import { Props_SnippetStatistics } from './Statistics.props'

const AnimatedNumber = ({ value }: { value: number }) => {
    const ref = useRef<HTMLSpanElement>(null)
    const inView = useInView(ref, { once: true })

    useEffect(() => {
        if (!inView || !ref.current) return

        const controls = animate(0, value, {
            duration: 5,
            ease: 'easeInOut',
            onUpdate(latest) {
                if (ref.current) {
                    ref.current.textContent = Math.round(latest).toLocaleString()
                }
            },
        })

        return () => controls.stop()
    }, [inView, value])

    return <span ref={ref}>0</span>
}

const Statistics = (props: Props_SnippetStatistics) => {
    const { snippet, heading, repeatable_entries } = props

    const classHeadingVisibility: string = heading.visibility.value ? `snippet-statistics__heading--${heading.visibility.value}` : ''
    const classSnippetTheme = `snippet-statistics--theme-${snippet.theme?.value}`

    return (
        <section className={`snippet-statistics ${classSnippetTheme}`}>
            <div className="snippet-statistics__container">
                <h2 className={`snippet-statistics__heading ${classHeadingVisibility}`}>{ heading.content.value }</h2>
                <div className="snippet-statistics__container-entries">
                    { repeatable_entries.map((stat, index) => (
                        <div className={`snippet-statistics__entry snippet-statistics__entry--${index + 1}`} key={index}>
                            <div className="snippet-statistics__entry-container-statistic">
                                <h3 className="snippet-statistics__entry-statistic-value">
                                    { stat.prepend?.value && <span className="snippet-statistics__entry-statistic-prepend">{ stat.prepend.value }</span> }
                                    { stat.statistic?.value && <span className="snippet-statistics__entry-statistic-value"><AnimatedNumber value={parseInt(stat.statistic.value)}/></span> }
                                    { stat.append?.value && <span className="snippet-statistics__entry-statistic-append">{stat.append.value}</span> }
                                </h3>
                            </div>
                            { stat.content?.value && <div className="snippet-statistics__entry-content">{ Legacy_CompileMarkdown(stat.content.value) }</div> }
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Statistics